<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-09-09 09:21:17
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">
      门店库存统计 （统计数据非实时统计，更新截止到前一天）
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClicks">
      <el-tab-pane label="零售统计" name="1">
        <el-tabs v-model="active" type="card" @tab-click="handleClick">
          <el-tab-pane label="门店零售出货统计(门店)" name="1">
            <el-form
              ref="form"
              :model="form1"
              label-width="100px"
              :inline="true"
              class="mt20"
            >
              <el-form-item label="零售出库时间" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form1.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form1.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="门店:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form1.from_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectStoreDialog = !selectStoreDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>
              <el-form-item label="门店类型:" style="margin-left:15px;">
                <el-select v-model="form1.to_level_id">
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option
                    :label="v.level_name"
                    :value="v.id"
                    v-for="(v, k) in ShopLeve"
                    :key="k"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>

            零售总数： {{ real_stock_out_num }}

            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column
                prop="from_sn"
                label="门店编号"
                fixed
              ></el-table-column>
              <el-table-column
                prop="from_name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="门店地址"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dealer_name"
                label="所属经销商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="real_stock_out_num"
                label="零售数量"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop
                label="操作"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)"
                    >查看明细</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="pageNo"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="门店零售出货统计(产品)" name="11">
            <el-form
              ref="form"
              :model="form11"
              label-width="100px"
              :inline="true"
              class="mt20"
            >
              <el-form-item label="零售出库时间" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form11.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form11.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="经销商/门店:">
                <el-col :span="15" style="margin-right:20px;">
                  <el-input v-model="form11.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectRoleDialog = !selectRoleDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>
              <el-form-item label="产品编号:">
                <el-input v-model="form11.product_sn" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form11.product_name" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-15"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>

            零售总数： {{ real_stock_out_num }}

            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData11"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column
                prop="from_sn"
                label="门店编号"
                fixed
              ></el-table-column>
              <el-table-column
                prop="from_name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="门店地址"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dealer_name"
                label="所属经销商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_sn"
                label="产品编号"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_name"
                label="产品名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="real_stock_out_num"
                label="零售数量"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange11"
              @current-change="handleCurrentChange11"
              :current-page="pageNo11"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize11"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize11"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="零售退货统计" name="2">
            <el-form
              ref="form"
              :model="form2"
              label-width="100px"
              :inline="true"
              class="mt20"
              ><el-form-item label="零售退货时间" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form2.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form2.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="门店:">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form2.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectStoreDialog = !selectStoreDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>

              <el-form-item label="门店类型:" style="margin-left:15px;">
                <el-select v-model="form2.to_level_id">
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option
                    :label="v.level_name"
                    :value="v.id"
                    v-for="(v, k) in ShopLeve"
                    :key="k"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>

            退货总数：{{ real_stock_out_num }}
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData1"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column
                prop="to_sn"
                label="门店编号"
                fixed
              ></el-table-column>
              <el-table-column
                prop="to_name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="门店地址"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dealer_name"
                label="所属经销商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="return_goods_num_total"
                label="退货数量"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop
                label="操作"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)"
                    >查看明细</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="pageNo1"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize1"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <el-tab-pane label="库存统计" name="2">
        <el-tabs v-model="active1" type="card" @tab-click="handleClick1">
          <el-tab-pane label="门店库存统计(门店)" name="1">
            <el-form
              ref="form"
              :model="form3"
              label-width="100px"
              :inline="true"
              class="mt20"
            >
              <!-- <el-form-item label="按日期统计" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form3.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form3.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item> -->
              <!-- <el-form-item label="门店:" style="margin-right:60px;">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form3.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectStoreDialog = !selectStoreDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item> -->
              <el-form-item label="经销商/门店:" style="margin-right:60px;">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form3.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectRoleDialog = !selectRoleDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>
              <!-- <el-form-item label="生产批次号:" v-if="isCodeShow">
                <el-input v-model="form3.production_batch" clearable></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="产品编号:">
                <el-input v-model="form3.product_sn" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form3.product_name" clearable></el-input>
              </el-form-item> -->

              <!-- <el-form-item label="门店类型:" style="margin-left:15px;">
                <el-select v-model="form3.to_level_id">
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option
                    :label="v.level_name"
                    :value="v.id"
                    v-for="(v, k) in ShopLeve"
                    :key="k"
                  ></el-option>
                </el-select>
              </el-form-item> -->

              <!--  -->

              <!--  -->
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            总共库存：{{ real_stock_out_num }}
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData2"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed>
                <template slot-scope="scope">
                  {{ scope.$index }}
                </template>
              </el-table-column>
              <el-table-column
                prop="to_sn"
                label="门店编号"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="to_name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="门店地址"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dealer_name"
                label="所属经销商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="residue_num"
                label="剩余数量"
                show-overflow-tooltip
              ></el-table-column>

              <el-table-column
                prop
                label="操作"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)"
                    >查看详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="pageNo2"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize2"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="门店库存统计(产品)" name="21">
            <el-form
              ref="form"
              :model="form21"
              label-width="100px"
              :inline="true"
              class="mt20"
            >
              <!-- <el-form-item label="按日期统计" style="text-align: center">
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="开始时间"
                    v-model="form21.start_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="结束时间"
                    v-model="form21.end_time"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-col>
              </el-form-item> -->
              <el-form-item label="经销商/门店:" style="margin-right:60px;">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form21.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectRoleDialog = !selectRoleDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>
              <el-form-item label="产品编号:">
                <el-input v-model="form21.product_sn" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form21.product_name" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form>
            总共库存：{{ real_stock_out_num }}
            <!--表格-->
            <el-table
              ref="multipleTable"
              :data="tableData21"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed>
                <template slot-scope="scope">
                  {{ scope.$index }}
                </template>
              </el-table-column>
              <el-table-column
                prop="to_sn"
                label="门店编号"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="to_name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="门店地址"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dealer_name"
                label="所属经销商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_sn"
                label="产品编号"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_name"
                label="产品名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="residue_num"
                label="库存数量"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange21"
              @current-change="handleCurrentChange21"
              :current-page="pageNo21"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize21"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize21"
            ></el-pagination>
          </el-tab-pane>
          <!-- <el-tab-pane label="门店库存统计(产品)" name="2"> -->
          <!-- <el-form
              ref="form"
              :model="form4"
              label-width="100px"
              :inline="true"
              class="mt20"
            >
              <el-form-item label="门店:" style="margin-right:60px;">
                <el-col :span="20" style="margin-right:20px;">
                  <el-input v-model="form4.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button @click="selectStoreDialog = !selectStoreDialog"
                    >选择</el-button
                  >
                </el-col>
              </el-form-item>

              <el-form-item label="生产批次号:" v-if="isCodeShow">
                <el-input v-model="form4.production_batch" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品编号:">
                <el-input v-model="form4.product_sn" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品名称:">
                <el-input v-model="form4.product_name" clearable></el-input>
              </el-form-item>
              <el-form-item label="门店类型:" style="margin-left:15px;">
                <el-select v-model="form4.to_level_id">
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option
                    :label="v.level_name"
                    :value="v.id"
                    v-for="(v, k) in ShopLeve"
                    :key="k"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch()" class="mr-10"
                  >搜索</el-button
                >
                <el-button @click="exportData()">导出</el-button>
              </el-form-item>
            </el-form> -->
          <!-- 总共库存：{{ real_stock_out_num }} -->
          <!--表格-->
          <!-- <el-table
              ref="multipleTable"
              :data="tableData3"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed>
                <template slot-scope="scope">
                  {{ scope.$index }}
                </template>
              </el-table-column>
              <el-table-column
                prop="product_sn"
                label="产品编号"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_name"
                label="产品名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="product_specs"
                label="规格"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="inwarehouse_num"
                label="入库数量"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="outwarehouse_num"
                label="零售数量"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="residue_num"
                label="剩余数量"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop
                label="操作"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)"
                    >查看详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange5"
              @current-change="handleCurrentChange5"
              :current-page="pageNo5"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize5"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize5"
            ></el-pagination> -->
          <!-- </el-tab-pane> -->
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="查看明细" :visible.sync="detailDialog" width="70%">
      <el-button @click="exportDetail">导出明细</el-button>

      <el-table
        ref="multipleTable"
        :data="tableData4"
        v-loading="loading"
        border
        stripe
        style="width: 100%;margin: 20px"
      >
        <el-table-column
          prop="logistics_code"
          label="物流码"
          show-overflow-tooltip
          v-if="activeName == 1"
        ></el-table-column>
        <el-table-column
          prop="production_batch"
          label="生产批次号"
          show-overflow-tooltip
          v-if="activeName == 2 && isCodeShow"
        ></el-table-column>
        <el-table-column
          prop="code_name"
          label="标签类型"
          show-overflow-tooltip
          v-if="activeName == 1"
        ></el-table-column>
        <el-table-column
          prop="product_sn"
          label="产品编号"
          show-overflow-tooltip
          v-if="active1 != 2"
        ></el-table-column>
        <el-table-column
          prop="product_name"
          label="产品名称"
          show-overflow-tooltip
          v-if="activeName == 2 && active1 == 1"
        ></el-table-column>
        <el-table-column
          prop="product_specs"
          label="产品规格"
          show-overflow-tooltip
          v-if="activeName == 2 && active1 == 2"
        ></el-table-column>
        <el-table-column
          prop="to_sn"
          label="门店编号"
          show-overflow-tooltip
          v-if="activeName == 2 && active1 == 2"
        >
        </el-table-column>
        <el-table-column
          prop="to_name"
          label="门店名称"
          show-overflow-tooltip
          v-if="activeName == 2 && active1 == 2"
        >
        </el-table-column>
        <el-table-column
          prop="real_stock_out_num"
          label="零售数量"
          show-overflow-tooltip
          v-if="activeName == 1 && active == 1"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="零售时间"
          show-overflow-tooltip
          v-if="activeName == 1 && active == 1"
        ></el-table-column>
        <el-table-column
          prop="real_return_goods_num"
          label="退货数量"
          show-overflow-tooltip
          v-if="activeName == 1 && active == 2"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="退货时间"
          show-overflow-tooltip
          v-if="activeName == 1 && active == 2"
        ></el-table-column>
        <el-table-column
          prop="inwarehouse_num"
          label="入库数量"
          show-overflow-tooltip
          v-if="activeName == 2"
        ></el-table-column>
        <el-table-column
          prop="outwarehouse_num"
          label="零售数量"
          show-overflow-tooltip
          v-if="activeName == 2"
        ></el-table-column>
        <el-table-column
          prop="residue_num"
          label="库存数量"
          show-overflow-tooltip
          v-if="activeName == 2"
        ></el-table-column>
        <el-table-column
          prop="production_date"
          label="生产日期"
          show-overflow-tooltip
          v-if="activeName == 2 && isCodeShow"
        ></el-table-column>
        <el-table-column
          prop="expiring_date"
          label="有效期至"
          show-overflow-tooltip
          v-if="activeName == 2 && isCodeShow"
        ></el-table-column>
        <el-table-column
          prop="source"
          label="来源"
          width="180"
          show-overflow-tooltip
          v-if="activeName == 1"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 20px 0"
        @size-change="handleSizeChange5"
        @current-change="handleCurrentChange5"
        :current-page="pageNo5"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageSize5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize5"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="(detailDialog = false), (pageSize5 = 10), (pageNo5 = 1)"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="(detailDialog = false), (pageSize5 = 10), (pageNo5 = 1)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <selectStore
      v-if="selectStoreDialog"
      v-on:handleClose="selectStoreDialog = false"
      @pushData="getSelectinfo"
    ></selectStore>
    <!--选择经销商/门店-->
    <selectRole
      v-if="selectRoleDialog"
      v-on:handleClose="selectRoleDialog = false"
      @pushData="getCust"
    >
    </selectRole>
    <!--批量导入-->
    <importData
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="onSearch"
    ></importData>
    <!--物流码明细-->
  </div>
</template>

<script>
import selectStore from "@/components/logistics/common/selectStore.vue";
import selectRole from "@/components/logistics/common/selectRole.vue";

export default {
  name: "deliver-manage",
  data() {
    return {
      activeName: "1",
      active: "1",
      active1: "1",

      loading: false,
      selectStoreDialog: false,
      selectRoleDialog: false,
      importDataDialog: false,
      real_stock_out_num: "", //零售总数
      form2: {
        to_sn: "",
        from_sn: "",
        from_level_id: "",
        to_level_id: "",
        end_time: "",
        start_time: "",
      },
      form4: {
        to_sn: "",
        to_level_id: "",
        production_batch: "",
        product_name: "",
        product_sn: "",
        end_time: "",
        start_time: "",
      },
      form3: {
        to_sn: "",
        to_type: "",
        to_level_id: "",
        production_batch: "",
        product_name: "",
        product_sn: "",
        end_time: "",
        start_time: "",
      },
      form1: {
        from_sn: "",
        from_level_id: "",
        end_time: "",
        start_time: "",
      },
      form11: {
        to_sn: "",
        to_type: "",
        product_name: "",
        product_sn: "",
        end_time: "",
        start_time: "",
      },
      form21: {
        to_sn: "",
        to_type: "",
        product_name: "",
        product_sn: "",
        end_time: "",
        start_time: "",
      },
      ShopLeve: [], //门店类型清单
      tableData: [],
      tableData11: [],
      tableData21: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      //分页
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      //分页
      pageNo11: 1,
      pageSize11: 10,
      totalSize11: 0,
      //分页
      pageNo21: 1,
      pageSize21: 10,
      totalSize21: 0,
      //分页
      pageNo1: 1,
      pageSize1: 10,
      totalSize1: 0,

      pageNo2: 1,
      pageSize2: 10,
      totalSize2: 0,
      pageNo3: 1,
      pageSize3: 10,
      totalSize3: 0,

      pageNo5: 1,
      pageSize5: 10,
      totalSize5: 0,
      detailDialog: false,
      stock_out_sn: "", //传给物流明细
      tempdata: {},
      isCodeShow: true,
    };
  },
  methods: {
    //获取基础配置
    getConfigInfo() {
      this.$get("logistics", "/configs", {
        lang: "",
      })
        .then((res) => {
          console.log(res);
          if (res.data.production_batch_on_off == 0) {
            this.isCodeShow = false;
          } else if (res.data.production_batch_on_off == 1) {
            this.isCodeShow = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取门店级别清单
    ShopLeves() {
      this.$get("logistics", "/shops.level", {
        lang: "",
      })
        .then((res) => {
          this.ShopLeve = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handleClicks() {
      this.onSearch();
    },
    handleClick() {
      this.onSearch();
    },
    getSelectinfo(val) {
      // console.log(val)
      if (this.activeName == 1 && this.active == 1) {
        this.form1.from_sn = val.shop_sn;
      } else if (this.activeName == 1 && this.active == 2) {
        this.form2.to_sn = val.shop_sn;
      } else if (this.activeName == 2 && this.active1 == 1) {
        this.form3.to_sn = val.shop_sn;
      } else {
        this.form4.to_sn = val.shop_sn;
      }
    },
    //获取经销商/门店
    getCust(val) {
      if (this.activeName == 1 && this.active == 11) {
        if (val.dealer_sn) {
          this.form11.to_sn = val.dealer_sn;
          this.form11.to_type = 2;
        } else if (val.shop_sn) {
          this.form11.to_sn = val.shop_sn;
          this.form11.to_type = 3;
        }
      } else if (this.activeName == 2 && this.active1 == 1) {
        if (val.dealer_sn) {
          this.form3.to_sn = val.dealer_sn;
          this.form3.to_type = 2;
        } else if (val.shop_sn) {
          this.form3.to_sn = val.shop_sn;
          this.form3.to_type = 3;
        }
      } else if (this.activeName == 2 && this.active1 == 21) {
        if (val.dealer_sn) {
          this.form21.to_sn = val.dealer_sn;
          this.form21.to_type = 2;
        } else if (val.shop_sn) {
          this.form21.to_sn = val.shop_sn;
          this.form21.to_type = 3;
        }
      }
    },
    // 查看明细
    detail(data) {
      this.detailDialog = true;
      this.loading = true;
      this.tempdata = data;
      this.getdetail();
    },
    getdetail() {
      if (this.activeName == 1 && this.active == 1) {
        // /shops.retails.outstock/datas
        this.setForm1Date();
        this.$get("logistics", "/shops.retails.outstock/datas", {
          start_time: this.form1.start_time,
          end_time: this.form1.end_time,
          from_sn: this.tempdata.from_sn,
          per_page: this.pageSize5,
          page: this.pageNo5,
        }).then((res) => {
          this.tableData4 = res.data;
          this.loading = false;
          this.totalSize5 = res.meta.total;
        });
      } else if (this.activeName == 1 && this.active == 2) {
        // /shops.retails.outstock/datas
        this.setForm2Date();
        this.$get("logistics", "/shops.retails.returngoods/datas", {
          start_time: this.form2.start_time,
          end_time: this.form2.end_time,
          to_sn: this.tempdata.to_sn,
          per_page: this.pageSize5,
          page: this.pageNo5,
        }).then((res) => {
          this.tableData4 = res.data;
          this.loading = false;
          this.totalSize5 = res.meta.total;
        });
      } else if (this.activeName == 2 && this.active1 == 1) {
        // /shops.retails.outstock/datas
        this.setForm3Date();
        this.$get("logistics", "/shops.stocks.total/datas", {
          start_time: this.form3.start_time,
          end_time: this.form3.end_time,
          to_sn: this.tempdata.to_sn,
          per_page: this.pageSize5,
          page: this.pageNo5,
        }).then((res) => {
          this.tableData4 = res.data;
          this.loading = false;
          this.totalSize5 = res.meta.total;
        });
      } else {
        this.$get("logistics", "/shops.stocks.products/datas", {
          product_sn: this.tempdata.product_sn,
          per_page: this.pageSize5,
          page: this.pageNo5,
        }).then((res) => {
          this.tableData4 = res.data;
          this.loading = false;
          this.totalSize5 = res.meta.total;
        });
      }
    },
    //请求列表数据
    onSearch() {
      this.loading = true;
      if (this.activeName == 1 && this.active == 1) {
        this.setForm1Date();
        this.$get("logistics", "/shops.retails.outstock", {
          lang: "",
          ...this.form1,
          per_page: this.pageSize,
          page: this.pageNo,
        })
          .then((res) => {
            this.loading = false;
            this.tableData = res.data;
            this.totalSize = res.meta.total;
            this.real_stock_out_num = res.real_stock_out_num;
          })
          .catch(function(error) {
            this.loading = false;
          });
      } else if (this.activeName == 1 && this.active == 11) {
        this.setForm11Date();
        this.$get("logistics", "/shops.retails.outproductstock", {
          lang: "",
          ...this.form11,
          per_page: this.pageSize11,
          page: this.pageNo11,
        })
          .then((res) => {
            this.loading = false;
            this.tableData11 = res.data;
            this.totalSize11 = res.meta.total;
            this.real_stock_out_num = res.real_stock_out_num;
          })
          .catch(function(error) {
            this.loading = false;
          });
      } else if (this.activeName == 1 && this.active == 2) {
        this.setForm2Date();
        this.$get("logistics", "/shops.retails.returngoods", {
          lang: "",
          ...this.form2,
          per_page: this.pageSize1,
          page: this.pageNo1,
        })
          .then((res) => {
            this.loading = false;
            this.tableData1 = res.data;
            this.totalSize1 = res.meta.total;
            this.real_stock_out_num = res.real_return_goods_num;
          })
          .catch(function() {
            this.loading = false;
          });
      } else if (this.activeName == 2 && this.active1 == 1) {
        this.setForm3Date();
        this.$get("logistics", "/shops.stocks.total", {
          lang: "",
          ...this.form3,
          per_page: this.pageSize2,
          page: this.pageNo2,
        })
          .then((res) => {
            this.loading = false;
            this.tableData2 = res.data;
            this.totalSize2 = res.meta.total;
            this.real_stock_out_num = res.real_stock_out_num;
          })
          .catch(function() {
            this.loading = false;
          });
      } else if (this.activeName == 2 && this.active1 == 21) {
        this.setForm21Date();
        this.$get("logistics", "/shops.stocks.shopsproducts", {
          lang: "",
          ...this.form21,
          per_page: this.pageSize21,
          page: this.pageNo21,
        })
          .then((res) => {
            this.loading = false;
            this.tableData21 = res.data;
            this.totalSize21 = res.meta.total;
            this.real_stock_out_num = res.real_stock_out_num;
          })
          .catch(function() {
            this.loading = false;
          });
      } else if (this.activeName == 2 && this.active1 == 2) {
        if (this.form4.start_time) {
          this.form4.start_time = this.moment(this.form4.start_time).format(
            "YYYY-MM-DD"
          );
        }
        if (this.form4.end_time) {
          this.form4.end_time = this.moment(this.form4.end_time).format(
            "YYYY-MM-DD"
          );
        }
        this.$get("logistics", "/shops.stocks.products", {
          lang: "",
          ...this.form4,
          per_page: this.pageSize3,
          page: this.pageNo3,
        })
          .then((res) => {
            this.loading = false;
            this.tableData3 = res.data;
            this.totalSize3 = res.meta.total;
            this.real_stock_out_num = res.real_stock_out_num;
          })
          .catch(function() {
            this.loading = false;
          });
      }
    },
    //选择经销商/门店
    selectType() {
      this.selectDealerDialog = true;
    },
    //导出
    exportData() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      if (this.activeName == 1 && this.active == 1) {
        this.setForm1Date();
        window.open(
          this.$Base_Export +
            "/shops.retails.outstock.export?" +
            "start_time=" +
            this.form1.start_time +
            "&end_time=" +
            this.form1.end_time +
            "&is_export=1" +
            "&from_sn=" +
            this.form1.from_sn +
            "&from_level_id=" +
            this.form1.from_level_id +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 1 && this.active == 11) {
        this.setForm11Date();
        window.open(
          this.$Base_Export +
            "/shops.retails.outproductstock.export?" +
            "start_time=" +
            this.form11.start_time +
            "&end_time=" +
            this.form11.end_time +
            "&is_export=1" +
            "&to_type=" +
            this.form11.to_type +
            "&to_sn=" +
            this.form11.to_sn +
            "&product_sn=" +
            this.form11.product_sn +
            "&product_name=" +
            this.form11.product_name +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 1 && this.active == 2) {
        this.setForm2Date();
        window.open(
          this.$Base_Export +
            "/shops.retails.returngoods.export?" +
            "start_time=" +
            this.form2.start_time +
            "&end_time=" +
            this.form2.end_time +
            "&is_export=1" +
            "&to_sn=" +
            this.form2.to_sn +
            "&to_level_id=" +
            this.form2.to_level_id +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 2 && this.active1 == 1) {
        this.setForm3Date();
        window.open(
          this.$Base_Export +
            "/shops.stocks.total.export?" +
            "start_time=" +
            this.form3.start_time +
            "&end_time=" +
            this.form3.end_time +
            "&is_export=1" +
            "&to_type=" +
            this.form3.to_type +
            "&to_sn=" +
            this.form3.to_sn +
            "&to_level_id=" +
            this.form3.to_level_id +
            "&product_sn=" +
            this.form3.product_sn +
            "&product_name=" +
            this.form3.product_name +
            "&production_batch=" +
            this.form3.production_batch +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 2 && this.active1 == 21) {
        this.setForm21Date();
        window.open(
          this.$Base_Export +
            "/shops.stocks.shopsproducts.export?" +
            "start_time=" +
            this.form21.start_time +
            "&end_time=" +
            this.form21.end_time +
            "&is_export=1" +
            "&to_type=" +
            this.form21.to_type +
            "&to_sn=" +
            this.form21.to_sn +
            "&product_sn=" +
            this.form21.product_sn +
            "&product_name=" +
            this.form21.product_name +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        this.setForm4Date();
        window.open(
          this.$Base_Export +
            "/shops.stocks.products.export?" +
            "start_time=" +
            this.form4.start_time +
            "&end_time=" +
            this.form4.end_time +
            "&is_export=1" +
            "&to_sn=" +
            this.form4.to_sn +
            "&to_level_id=" +
            this.form4.to_level_id +
            "&product_sn=" +
            this.form4.product_sn +
            "&product_name=" +
            this.form4.product_name +
            "&production_batch=" +
            this.form4.production_batch +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    exportDetail() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      if (this.activeName == 1 && this.active == 1) {
        this.setForm1Date();
        window.open(
          this.$Base_Export +
            "/shops.retails.outstock/datas.export?" +
            "start_time=" +
            this.form1.start_time +
            "&end_time=" +
            this.form1.end_time +
            "&is_export=1" +
            "&from_sn=" +
            this.tempdata.from_sn +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 1 && this.active == 2) {
        this.setForm2Date();
        window.open(
          this.$Base_Export +
            "/shops.retails.returngoods/datas.export?" +
            "start_time=" +
            this.form2.start_time +
            "&end_time=" +
            this.form2.end_time +
            "&is_export=1" +
            "&to_sn=" +
            this.tempdata.to_sn +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else if (this.activeName == 2 && this.active1 == 1) {
        this.setForm3Date();
        window.open(
          this.$Base_Export +
            "/shops.stocks.total/datas.export?" +
            "start_time=" +
            this.form3.start_time +
            "&end_time=" +
            this.form3.end_time +
            "&is_export=1" +
            "&to_sn=" +
            this.tempdata.to_sn +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        this.setForm4Date();
        window.open(
          this.$Base_Export +
            "/shops.stocks.products/datas.export?" +
            "start_time=" +
            this.form4.start_time +
            "&end_time=" +
            this.form4.end_time +
            "&is_export=1" +
            "&product_sn=" +
            this.tempdata.product_sn +
            "&lang=" +
            "" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    //日期参数初始化
    setForm1Date() {
      if (this.form1.start_time) {
        this.form1.start_time = this.moment(this.form1.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form1.end_time) {
        this.form1.end_time = this.moment(this.form1.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    setForm11Date() {
      if (this.form11.start_time) {
        this.form11.start_time = this.moment(this.form11.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form11.end_time) {
        this.form11.end_time = this.moment(this.form11.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    setForm2Date() {
      if (this.form2.start_time) {
        this.form2.start_time = this.moment(this.form2.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form2.end_time) {
        this.form2.end_time = this.moment(this.form2.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    setForm3Date() {
      if (this.form3.start_time) {
        this.form3.start_time = this.moment(this.form3.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form3.end_time) {
        this.form3.end_time = this.moment(this.form3.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    setForm21Date() {
      if (this.form21.start_time) {
        this.form21.start_time = this.moment(this.form21.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form21.end_time) {
        this.form21.end_time = this.moment(this.form21.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    setForm4Date() {
      if (this.form4.start_time) {
        this.form4.start_time = this.moment(this.form4.start_time).format(
          "YYYY-MM-DD"
        );
      }
      if (this.form4.end_time) {
        this.form4.end_time = this.moment(this.form4.end_time).format(
          "YYYY-MM-DD"
        );
      }
    },
    //发货标签码明细
    deliverDetail(row) {
      this.stock_out_sn = row.stock_out_sn;
      this.deliverCodeDialog = true;
    },
    handleSizeChange2(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      this.onSearch();
    },
    handleCurrentChange2(val) {
      this.pageNo1 = val;
      this.onSearch();
    },
    handleSizeChange3(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.onSearch();
    },
    handleCurrentChange3(val) {
      this.pageNo2 = val;
      this.onSearch();
    },
    handleSizeChange4(val) {
      this.pageSize3 = val;
      this.pageNo3 = 1;
      this.onSearch();
    },

    handleCurrentChange4(val) {
      this.pageNo3 = val;
      this.onSearch();
    },

    handleSizeChange5(val) {
      this.pageSize5 = val;
      this.pageNo5 = 1;
      this.getdetail();
    },

    handleCurrentChange5(val) {
      this.pageNo5 = val;
      this.getdetail();
    },
    /*分页*/
    handleSizeChange1(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo = val;
      this.onSearch();
    },
    /*分页*/
    handleSizeChange11(val) {
      this.pageSize11 = val;
      this.pageNo11 = 1;
      this.onSearch();
    },
    handleCurrentChange11(val) {
      this.pageNo11 = val;
      this.onSearch();
    },
    /*分页*/
    handleSizeChange21(val) {
      this.pageSize21 = val;
      this.pageNo21 = 1;
      this.onSearch();
    },
    handleCurrentChange21(val) {
      this.pageNo21 = val;
      this.onSearch();
    },
    /*分页*/
    handleClick1() {
      this.onSearch();
    },
  },
  created() {
    this.ShopLeves();
    this.onSearch();
    this.getConfigInfo();
  },
  components: {
    selectStore,
    selectRole,
  },
};
</script>
<style lang="scss" scoped>
.container .pageTitle {
  height: auto;
  margin-bottom: 10px;
}
/deep/.el-table {
  overflow-x: scroll;
}
</style>
